export default {
  'current_lang': '语言 (ZH)',
  'chinese_zh': '中文简体',
  'chinese_tw': '中文繁体',
  'english': '英文',
  'general': {
    'list': {
      'display': '顯示',
      'to': '至',
      'of': '於',
      'records': '紀錄當中',
      'prev': '上一個',
      'next': '下一個',
    },
    'input': {
      'please_select_status': '請選擇一個狀態',
      'please_select_courier': '請選擇一個速遞商',
      'please_select_a_shipping_method': '請選擇速遞方式編碼',
      'please_select_a_incoterm': 'Please select a incoterm',
      'please_select_courier_service': 'Please select a courier service',
    },
    'button': {
      'add': '加入',
      'delete': '刪除',
      'ok': '確定',
      'submit': '發送',
    },
    'action': '操作',
    'create': '創建',
    'edit': '編輯',
    'yes': '是',
    'no': '否',
  },
  'sidebar': {
    'dashboard': '仪表盘',
    'shipment': 'Shipments',
    'label':'Labels',
    'pending_order': '待确认订单',
    'delivery_order': '发货订单',
    'delivery_audit_weight': '更新预报重量',
    'delivery_inbound': '已入仓订单',
    'delivery_outbound': '已发货订单',
    'marketplace': 'Marketplace',
    'marketplace_order': 'Marketplace Order',
    'marketplace_store': 'Marketplace Store',
    'shipper': '发货人',
    'courier': '快递',
    'contact_message': 'Contact Message',
    'comparison_tool': '比价工具',
    'tracking': 'Tracking Status',
    'marketplace_upload_order_tracking': 'Upload Tracking',
    'marketplace_pending_accept': 'Pending Accepts',
    'marketplace_order_shipment': 'Uploaded Shipments'
  },
  'breadcrumb': {
    'home': '首页',
    'dashboard': '仪表盘',
    'delivery': '发货',
    'pending': '待定',
    'pending_order': '待确认订单',
    'inbound_list': 'Inbound Shipments',
    'outbound_list': 'Outbound Shipments',
    'delivery_audit_weight': 'Audit Shipment Weight',
    'upload_delivery_audit_weight': 'Upload Audit Weight',
    'audit_list': 'Audit Shipments',
    'not_audit_list': 'Not Audit Shipments',
    'order_create': '创建订单',
    'order_edit': '修改订单',
    'order_show': '订单详情',
    'order_upload': '上传订单',
    'order': '订单',
    'order_list': '订单列表',
    'order_detail': '订单详情',
    'marketplace_order': 'Marketplace Order',
    'marketplace_order_list': 'Marketplace Order List',
    'store': 'Store',
    'store_list': 'Store List',
    'shipper': '发货人',
    'shipper_list': '发货人列表',
    'shipper_create': '创建发货人',
    'shipper_edit': '修改发货人',
    'courier_list': '快递列表',
    'marketplace': 'Marketplace',
    'track': 'Delivery Track',
    'track_list': 'Delivery Track List',
    'upload_marketplace_order_tracking': 'Upload Marketplace Order Tracking',
    'user': 'User',
    'contact_message': 'Contact Message',
    'contact_message_list': 'Contact Message List',
    'update_password': 'Update Password',
    'marketplace_order_shipment': 'Marketplace Order Shipment',
    'contact_message_edit': 'Contact Message Edit'
  },
  'delivery': {
    'shipment': {
      'courier': 'Courier',
      'reference_no': 'Reference No.',
      'tracking_no': 'Tracking No.',
      'status': 'Status',
      'courier_name': 'Courier Name',
      'courier_slug': 'Courier Slug',
      'pickup_note': 'Pickup Note',
      'signed_by': 'Signed By',
      'lead_time': 'Lead Time',
      'updated_at': 'Updated At',
      'operation': 'Operation',
      'filter_option': 'Filter Option',
      'shipment_date': 'Shipment Date',
      'please_enter_reference_no': 'Please enter your reference no.',
      'enter_reference_no': 'Enter Reference No..',
      'please_enter_tracking_no': 'Please enter your tracking No.',
      'enter_tracking_no': 'Enter Tracking No.',
      'search': 'Search',
      'reset': 'Reset',
    },
    'label': {
      'sender_info': '寄貨人資料',
      'item_details': '貨件資料',
      'pending_order': '待定訂單',
      'pending': '待定',
      'inbound': '待發貨',
      'outbound': '已出貨',
      'orders': '訂單',
      'filter_option': '过滤选项',
      'batch_id': '批次号码',
      'enter_batch_id': '输入批次号码...',
      'upload_order_date': '订单上载日子',
      'reference_no': '参考号',
      'service_name': 'Courier Service Name',
      'service_code': 'Service Code',
      'please_enter_reference_no': '请输入参考号',
      'enter_reference_no': '输入参考号...',
      'waybill_number': '运单号.',
      'tracking_no': '跟踪号.',
      'please_enter_tracking_no': '请输入跟踪号.',
      'enter_tracking_no': '输入跟踪号...',
      'please_enter_waybill_number': '请输入运单号.',
      'enter_waybill_number': '输入运单号...',
      'search': '搜寻',
      'reset': '重设',
      'print_all': '全部列印',
      'ship_date': '发货日子',
      'weight': '重量',
      'product_type': 'Product Type',
      'package_num': '所須貼紙數量',
      'delivery_name': '收货人',
      'pieces': '件数',
      'api_failed_message': 'Failed Message',
      'status': '状态',
      'order_status': '订单状态',
      'tracking_status': 'Tracking Status',
      'updated_at': '更新日期',
      'system_status': 'LME系统状态',
      'active': '正常',
      'in_active': '取消',
      'operation': '操作',
      'print_selected_orders': '列印已选订单',
      'print_batch_orders': '列印批次订单',
      'please_select_batch': '请选择一个批次来列印',
      'please_select_order': '请选择一个订单来列印',
      'courier_name': '快递名称',
      'email': '电邮',
      'company': '公司名称',
      'address': '地址',
      'address1': '地址(行1)',
      'address2': '地址(行2)',
      'city': '城市',
      'postal_code': '邮政编码',
      'state': '省',
      'country': '国家',
      'country_code': '国家编号',
      'shipment_content': '货物描述',
      'phone': '电话',
      'district': '地区',
      'battery': '电池',
      'insurance_value': '保险值',
      'shipping_code': 'Courier Shipping Method Code',
      'incoterm': 'Incoterm',
      'weight_unit': '重量单位',
      'height': '高',
      'width': '阔',
      'length': '长',
      'dimension_uom': '尺寸单位',
      'remark': '备注',
      'courier_reference_id': '发货参考号',
      'number_of_pieces': '件数',
      'declared_currency': '报关货币',
      'declared_value': '报关价值',
      'extra_instruction': '特别指示',
      'order_upload_date': '订单上载时间',
      'created_date': '创建时间',
      'created_at': '创建时间',
      'not_allow_edit': '不能編輯訂單，請檢查訂單狀態',
      'update_pending_success': '成功更新待发订单',
      'create_pending_success': '成功创建待发订单',
      'download_ready_to_ship_order': '下載準備發貨送貨單',
      'pick_up_shipment': '設置送貨單為 - 已提貨',
      'download_below_order': '下載送貨單 - 下列顯示的全部',
      'download_not_delivered_order': '下載送貨單 - 未簽收'
    },
    'label_detail': {
      'line_no': '行数',
      'sku': 'SKU (最小存貨單位)',
      'product_name': '产品',
      'description_export': '出口描述',
      'description_import': '入口描述',
      'country_of_origin': '来源地',
      'quantity': '数量',
      'item_declared_value': '项目报关值',
      'hscode': '商品名称及编码协调制度(HS Code)',
      'hsdescription': 'HS Code 描述',
      'created_at': '生成时间'
    },
    'order_risk': {
      'platform_order_id': 'Platform Order Id',
      'platform': 'Platform',
      'platform_risk_id': 'Platform Risk Id',
      'checkout_id': 'Checkout Id',
      'recommendation': 'Recommendation',
      'display': 'Display',
      'cause_cancel': 'Cause Cancel',
      'message': 'Message',
      'merchant_message': 'Merchant Message'
    },
    'warning': {
      'please_input_all_the_required_information': '請先輸入上述所需要的資料',
    }
  },
  'marketplace': {
    'marketplace_name': 'Marketplace Name',
    'marketplace_store': 'Marketplace Store',
    'marketplace_courier': 'Marketplace Courier',
    'order': {
      'filter_option': 'Filter Option',
      'created_order_date': 'Created Order Date',
      'platform_order_id': 'Platform ID',
      'please_enter_platform_order_id': 'Please enter your platform order id',
      'enter_platform_order_id': 'Enter Platform ID',
      'please_enter_tracking_no': 'Please enter your tracking no.',
      'enter_tracking_no': 'Enter Tracking No..',
      'platform': 'Platform',
      'please_select_platform': 'Please select your platform',
      'search': 'Search',
      'reset': 'Reset',
      'sync_update': 'Sync & Update Order',
      'purchase_date': 'Purchase Date',
      'total_amount': 'Total Amount',
      'total_commission': 'Total Commission',
      'status': 'Status',
      'tracking_status':'Tracking Status',
      'active': 'Active',
      'in_active': 'InActive',
      'operation': 'Operation',
      'currency': 'Currency',
      'order_status': 'Order Status',
      'platform_order_status': 'Platform Order Status',
      'queue_job_status': 'Queue Job Status',
      'created_date': 'Created Date',
      'please_select_order': 'Please select an order ID to print the label',
      'courier_name': 'Courier Name',
      'email': 'Email',
      'company': 'Company Name',
      'battery': 'Battery',
      'bill_name': 'Bill Name',
      'bill_phone': 'Bill Phones Number',
      'bill_postal_code': 'Bill Postal Code',
      'bill_country': 'Bill Country',
      'bill_city': 'Bill City',
      'bill_district': 'Bill District',
      'bill_address': 'Bill Address',
      'shipping_name': 'Shipping Name',
      'shipping_phone': 'Shipping Phones Number',
      'shipping_postal_code': 'Shipping Postal Code',
      'shipping_country': 'Shipping Country',
      'shipping_city': 'Shipping City',
      'shipping_district': 'Shipping District',
      'shipping_address': 'Shipping Address',
      'created_at': 'Create At',
      'not_allow_edit': 'Not allow to edit this order, please check the order status',
      'update_pending_success': 'Update Pending Delivery Label Success',
      'create_pending_success': 'Create Pending Delivery Label Success',
      'platform_courier_name': 'Platform Courier Name',
      'platform_order_item_id': 'Platform Order Item Id',
      'tracking_no': 'Tracking No',
      'message': 'Message'
    },
    'order_detail': {
      'platform_order_id': 'Platform Order Id',
      'order_item_id': 'Order Item Id',
      'title': 'Title',
      'quantity_ordered': 'Quantity Ordered',
      'shipping_type': 'Shipping Type',
      'item_price': 'Item Price',
      'imei_code': 'IMEI Code',
      'shipping_price': 'Shipping Price',
      'total_commission': 'Total Commission',
      'tracking_no': 'Tracking No',
      'status': 'Status',
      'created_at': 'Create At'
    },
    'contact': {
      'message_type': 'Message Type',
      'contact_user_message': 'Contact User Message'
    },
    'store': {
      'store_account': 'Store Account',
      'store_name': 'Store Name',
      'store_user_id': 'Store User ID',
      'store_token': 'Store Token',
      'store_email': 'Store Email',
      'store_currency': 'Store Currency',
      'service_url': 'Service Url',
      'time_schedule': 'Time Schedule',
      'debug': 'Debug',
      'remark': 'Remark',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'success_message': 'Update Marketplace Store Success!'
    }
  },
  'track': {
    'delivery_order_no': 'delivery Order No',
    'waybill_number': 'Waybill Number',
    'route_description': 'Route Description',
    'route_date': 'Route Date',
    'route_status': 'Route Status',
    'updated_by': 'Updated By',
    'created_by': 'Created By',
    'collect': 'Collect',
    'signed': 'Signed',
    'transporting': 'Transporting',
    'operation': 'Operation'
  },
  'shipper': {
    'courier_name': '快递名称',
    'shipper_account': '发货人帐户',
    'billing_account': '计费帐户',
    'duty_account': '税项帐户',
    'shipper_id': '发货人编号(ID)',
    'shipper_name': '发货人名称',
    'registered_account': '登记账户',
    'address_line_1': '地址(行1)',
    'address_line_2': '地址(行2)',
    'city': '成市',
    'postal_code': '邮政编码',
    'division': '分区',
    'division_code': '分区编号',
    'country_code': '国家编号',
    'country_name': '国家',
    'contact_person': '联系人',
    'contact_phone': '联系电话',
    'status': '状态',
    'operation': '操作',
    'active': '正常',
    'in_active': '取消',
    'submit': '提交',
    'success_message': '成功更新发货人账户资料!'
  },
  'courier': {
    'courier_name': '快递名称',
    'incoterm': '国贸条件(incoterms)',
    'fuel_surcharge': '燃油附加费 (%)',
    'currency': '汇率',
    'lead_time': '前置时间',
    'status': '状态'
  },
  'comparison_tool': {
    'destination_country': '目标国家',
    'destination_state': '目标州分',
    'warehouse': '仓库',
    'postal_code': '邮政编码',
    'weight': '重量 (kg)',
    'service_type': '服务类别',
    'battery_type': '电池类别',
    'incoterm': '国贸条件(incoterms)',
    'max_dimension': '最大尺寸'
  },
  'login': {
    'sign_in_account': '登入你的账户',
    'login': '登入',
    'email': '电邮',
    'password': '密码',
    'forgot_password': '忘记密码?',
    'register_now': '马上登记!',
    'sign_up': '注册'
  },
  'error': {
    'search': '搜寻',
    'oops_message': '错误，请再登入',
    'page_not_found': '找不到页面',
    'houston_problem': 'Houston, 有点问题发生!',
    'what_looking_for': '在找什么?',
    'temporarily_unavailable': '你所找寻的页面暂时不能使用'
  },
  'operation': {
    'delete': {
      'title': '确定?',
      'text': '这个动作是不能回复的!',
      'confirm_button': '是，请删除!'
    },
    'claim': {
      'title': 'Are you sure?',
      'text': 'You will claim the invoice item!',
      'confirm_button': 'Yes, claim it!'
    }
  },
  'dashboard': {
    'marketplace': {
      'marketplace_order': '網上市集訂單',
      'order_request_date': '訂購日期',
      'total': '總數',
      'total_amounts': 'Total Amounts',
      'currency': 'Currency'
    },
    'currency': {
      'currency_rate': '貨幣',
      'from': '從',
      'to': '到',
      'rate': '匯率',
      'updated_at': '更新日期'
    }
  }
}
